import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { SharedService } from './shared/shared.service';
import { LocalStorageService } from './local-storage/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  return next(req).pipe(
    catchError(error => {
      if (error.status === 401) {
        // Clear all stored data
        localStorageService.removeItem('auth_token');
        localStorageService.removeItem('auth_user');

        // Redirect to login
        router.navigate(['/auth/login']);
      }
      return throwError(() => error);
    })
  );
};
